import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import moment from 'moment'
import { Button, Empty, Form, Icon, Input, message, Modal, Select, Spin, Switch, Table } from 'antd'
import EditCommissionRow from '@components/Popup/EditCommissionRow'
import CreateCommissionRow from '@components/Popup/CreateCommissionRow'
import SendFinanceSms from '@components/Popup/SendFinanceSms'
import { commissions, mentors } from '@services/api'
import { literalMonth, dateForApi } from '@utils/index'
import { titles } from '@pages/GeneralRequest/Utils/settings'
// prettier-ignore
import { main_container, select_row, right_col, select, input_row, input_element, loader_container, none, hRef, rowBG, sumContent, container, unsetMargin, tableClass, flex, switchRow } from './style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
class Reports extends Component<any> {
    refreshTimer: any = null

    columns = [
        {
            title: 'שולם',
            key: 'payed',
            align: 'center',
            width: 50,
            render: (_, { payed }) => this.payedDiv(payed)
        },
        {
            title: 'תאריך דו"ח',
            key: 'report_date',
            align: 'center',
            width: 100,
            render: (_, { report_date }) => this.dateFormatter(report_date, 'MM/YY')
        },
        {
            title: 'תאריך רכישה',
            key: 'paid_at',
            align: 'center',
            width: 130,
            render: (_, { paid_at }) => (paid_at ? this.dateFormatter(paid_at, 'DD/MM/YY') : '-')
        },
        {
            title: 'שם לקוח',
            key: 'client_name',
            align: 'right',
            width: 340,
            render: (_, { client_name, client_id }) => this.userDiv(client_name, client_id, 'clients')
        },
        {
            title: 'שם סוכן',
            key: 'agent_name',
            align: 'right',
            width: 340,

            render: (_, { agent_name, agent_id }) => this.userDiv(agent_name, agent_id, 'agents')
        },
        {
            title: 'שם מנטור',
            key: 'mentor',
            align: 'right',
            width: 140,

            render: (_, { mentor }) => <div>{mentor}</div>
        },
        {
            title: 'עלות',
            key: 'price',
            align: 'center',
            width: 50,

            render: (_, { price }) => this.sumFormatter(price)
        },
        {
            title: 'שנתי',
            key: 'yearly',
            align: 'center',
            width: 120,

            render: (_, { yearly }) => this.sumFormatter(yearly)
        },
        {
            title: 'עמלה',
            key: 'commission',
            align: 'center',
            width: 120,

            render: (_, { commission }) => this.sumFormatter(commission)
        },
        {
            title: 'שם המוצר',
            key: 'heb_class',
            align: 'center',
            width: 180,
            render: (_, { heb_class }) => <div>{heb_class}</div>
        },
        {
            title: 'שם המנוי',
            key: 'sub_name',
            align: 'right',
            width: 400,

            render: (_, { subscription_name, sub_name }) => (
                <div style={{ direction: 'rtl' }}>{subscription_name || sub_name}</div>
            )
        },
        {
            title: 'הערה',
            key: 'comment',
            align: 'center',
            width: 90,
            render: (_, { comment }) => (
                <a href={'#'} className={`${hRef} ${comment ? '' : none}`} onClick={() => this.infoModal(comment)}>
                    {'להערה'}
                </a>
            )
        },
        {
            title: '',
            key: 'edit',
            align: 'center',
            fixed: 'left',
            width: 50,
            render: (_, record) => {
                return this.canIEdit(record.payed) ? (
                    <Icon
                        type="setting"
                        style={{ color: 'orange', cursor: 'pointer' }}
                        onClick={() => this.onEditRow(record)}
                    />
                ) : null
            }
        },
        {
            title: '',
            key: 'delete',
            align: 'center',
            fixed: 'left',
            width: 50,
            render: (_, { id, payed }) => {
                return this.canIEdit(payed) ? (
                    <Icon
                        type="delete"
                        style={{ color: 'red', cursor: 'pointer' }}
                        onClick={() => this.deleteModal(id)}
                    />
                ) : null
            }
        }
    ]

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            list: [],
            total: 0,
            pageSize: 0,
            current: 1,
            loadData: false,
            loadingFile: false,
            // search by year
            yearRange: [],
            selectedYear: 'בחרו שנה',
            selectedYearEnd: 'בחרו שנה',
            // search by month
            monthRange: [],
            selectedMonth: 'בחרו חודש',
            selectedMonthEnd: 'בחרו חודש',
            monthRangeEnd: [],
            // date range search status
            rangeActive: false,
            // search by agent/client
            agent_id: '',
            client_id: '',
            // delete/edit/create row
            editRow: '',
            editData: null,
            createData: false,
            sendSms: false,
            // static data from db
            mentors: [],
            productList: [],
            //
            isFoundByUserId: false
        }
    }

    componentDidMount() {
        this.getCommissionRows(1, true)
        mentors.getAllMentors({}).then(({ data }) => this.setState({ mentors: data }))
        commissions.getProductsForEditCommission({}).then(({ data }) => {
            const productList = data.map((item: any) => ({ ...item, products: JSON.parse(item.products) }))
            this.setState({ productList })
        })
    }

    componentWillUnmount() {
        clearTimeout(this.refreshTimer)
    }

    canIEdit = (payed: number) => {
        // prettier-ignore
        const { authStore: { roles } } = this.props
        return (roles.includes('admin') || roles.includes('money')) && !!!payed
    }

    serverErrorMsg = (err: any) => Modal.error({ title: 'שגיאת שרת', content: err })
    loadFileErrorMsg = (err: any) => Modal.error({ title: 'שגיאת הורדה', content: err })

    infoModal = text => Modal.info({ title: text, okType: 'primary' })

    deleteModal = id => {
        this.setState({ editRow: id })
        Modal.confirm({
            content: 'האם למחוק עמלה?',
            okType: 'danger',
            okText: titles.confirm,
            cancelText: 'ביטול',
            onCancel: () => this.setState({ editRow: '' }),
            onOk: () => this.deleteCommissionRow(id)
        })
    }

    onEditRow = data => {
        // prettier-ignore
        const { popupStore: { togglePopup } } = this.props
        this.setState({ editData: data, editRow: data.id }, () => togglePopup('editCommissionRowPopup'))
    }

    onSmsPopup = () => {
        // prettier-ignore
        const { popupStore: { togglePopup } } = this.props
        this.setState({ sendSms: true }, () => togglePopup('commissionSmsPopup'))
    }

    onCreateRow = () => {
        // prettier-ignore
        const { popupStore: { togglePopup } } = this.props
        this.setState({ createData: true }, () => togglePopup('createCommissionRowPopup'))
    }

    getCommissionRows = (page = 1, isInitial) => {
        // prettier-ignore
        const {
            agent_id, client_id, rangeActive, selectedYear, selectedMonth, selectedYearEnd, selectedMonthEnd
        } = this.state
        this.setState({ loadData: true })
        const report_date = dateForApi(selectedYear, selectedMonth)
        const report_date_end = dateForApi(selectedYearEnd, selectedMonthEnd)
        const date_ranges = { start_date: report_date, end_date: report_date_end }

        commissions
            .commissionsDB({ page, report_date, agent_id, client_id, isInitial, rangeActive, date_ranges })
            .then(({ data }) => {
                const { data: list, total, perPage: pageSize, page, yearRange, isFoundByUserId } = data
                this.setState({ list, total, pageSize, current: page, yearRange, isFoundByUserId })
            })
            .catch(() => this.serverErrorMsg('שגיאת קבלת עמלות'))
            .finally(() => this.setState({ loadData: false }))
    }

    deleteCommissionRow = id => {
        const { current } = this.state
        commissions
            .deleteCommissionRow({ id })
            .then(() => this.getCommissionRows(current, true))
            .catch(() => this.serverErrorMsg('שגיאת הסרת עמלה'))
            .finally(() => this.setState({ editRow: '' }))
    }

    onLoadExcel = () => {
        this.setState({ loadingFile: true })
        // prettier-ignore
        const {
            isFoundByUserId, rangeActive, agent_id, client_id, selectedYear, selectedMonth, selectedYearEnd, selectedMonthEnd, current: page
        } = this.state

        const report_date = dateForApi(selectedYear, selectedMonth)
        const report_date_end = dateForApi(selectedYearEnd, selectedMonthEnd)
        const date_ranges = { start_date: report_date, end_date: report_date_end }

        if (!isFoundByUserId && rangeActive) {
            this.setState({ loadingFile: false })
            return this.loadFileErrorMsg('לא ניתן ליצור קובץ עמלות תקופתי ללא סינון של לקוח או סוכן')
        }

        commissions
            .enqueueClientsFile({
                page,
                report_date,
                agent_id,
                client_id,
                rangeActive,
                date_ranges,
                isInitial: true,
                isCurrentMonthReport: false
            })
            .then(() => {
                message.info('הקובץ בהכנה, יופיע ברשימת הקבצים בעוד מספר דקות')
                clearTimeout(this.refreshTimer)
                this.refreshTimer = setTimeout(() => this.props.getCommissionExportFiles(), 60000)
            })
            .catch(() => this.serverErrorMsg('שגיאת הורדת קובץ'))
            .finally(() => this.setState({ loadingFile: false }))
    }

    resetSearchData = event => {
        this.setState(
            // prettier-ignore
            {
                client_id: '', agent_id: '', monthRange: [], selectedMonth: 'בחרו חודש', selectedYear: 'בחרו שנה', selectedYearEnd: 'בחרו שנה',
                selectedMonthEnd: 'בחרו חודש', monthRangeEnd: [], editRow: '', editData: null, loadingFile: false, isFoundByUserId: false
            },
            () => {
                if (typeof event !== 'object') return
                return this.setState({ rangeActive: false }, () => {
                    this.getCommissionRows(1, true)
                })
            }
        )
    }

    handleYearSelect = (selectedYear: string) => {
        const { year, months } = JSON.parse(selectedYear)
        this.setState({
            selectedYear: year,
            monthRange: months,
            selectedMonth: 'בחרו חודש',
            selectedYearEnd: 'בחרו שנה',
            monthRangeEnd: [],
            selectedMonthEnd: 'בחרו חודש'
        })
    }

    handleYearSelectEnd = (selectedYear: string) => {
        const { year, months } = JSON.parse(selectedYear)
        this.setState({ selectedYearEnd: year, monthRangeEnd: months, selectedMonthEnd: 'בחר חודש' })
    }

    handleMonthSelect = (month, key) => {
        this.setState({ [key]: month })
        if (key === 'selectedMonth') {
            this.setState({
                selectedYearEnd: 'בחרו שנה',
                monthRangeEnd: [],
                selectedMonthEnd: 'בחרו חודש'
            })
        }
    }

    onSearch = e => {
        e.preventDefault()
        this.getCommissionRows(1, true)
    }

    onNumberInput = (event, key, _, reg) => _.setState({ [key]: event.value.replace(reg, '') })

    onRangeSwitch = bool => this.setState({ rangeActive: bool }, () => this.resetSearchData(false))

    dateFormatter = (date, format) => <div>{moment(date).format(format)}</div>

    payedDiv = i => <Icon type={i ? `check` : 'close'} style={{ color: i ? 'green' : 'red' }} />

    userDiv = (name, id, role) => (
        <div>
            {name}
            {' - '}
            <a target={'_blank'} href={`/${role}/${id}`} className={hRef}>{`${id}`}</a>
        </div>
    )

    sumFormatter = num => {
        if (num === undefined || num === null) return ''
        const color = parseFloat(num) < 0 ? 'red' : 'green'
        let formatted = num.toFixed(2)
        if (formatted.includes('.') && formatted.endsWith('00')) formatted = parseFloat(formatted).toString()
        const str = formatted.toString()
        const parts = str.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        return (
            <div className={sumContent} style={{ color: color }}>
                {parts.join('.')}
            </div>
        )
    }

    render() {
        // prettier-ignore
        const { createData, list, total, pageSize, current, loadingFile, yearRange, selectedYear, monthRange, selectedMonth, sendSms,
                agent_id, client_id, loadData, editRow, editData, rangeActive, selectedYearEnd, selectedMonthEnd, monthRangeEnd
        } = this.state
        // prettier-ignore
        const { onSmsPopup, onCreateRow, handleYearSelect, onLoadExcel, handleMonthSelect, onNumberInput, resetSearchData, getCommissionRows, onSearch, onRangeSwitch, handleYearSelectEnd, columns } = this
        const rClass = record => (record.id === editRow ? rowBG : record.id + '')
        const downloadBtnType = loadingFile ? 'loading' : 'download'

        return (
            <div className={container}>
                {editData ? <EditCommissionRow data={editData} events={this} /> : null}
                {createData ? <CreateCommissionRow events={this} /> : null}
                {sendSms ? <SendFinanceSms events={this} /> : null}
                <div className={main_container}>
                    <div className={right_col}>
                        <div className={select_row}>
                            <div className={switchRow}>
                                <div style={{ marginLeft: '15px' }}>טווח תאריכים</div>
                                <Switch checked={rangeActive} onClick={onRangeSwitch} />
                            </div>
                            <Select className={select} value={selectedYear} onChange={handleYearSelect}>
                                {yearRange.map(data => (
                                    <Select.Option key={data.year} value={JSON.stringify(data)}>
                                        {data.year}
                                    </Select.Option>
                                ))}
                            </Select>
                            <Select
                                className={select}
                                disabled={!!!monthRange.length}
                                value={literalMonth[selectedMonth] || selectedMonth}
                                onChange={e => handleMonthSelect(e, 'selectedMonth')}
                            >
                                {monthRange.length &&
                                    monthRange.map(month => (
                                        <Select.Option key={month} value={month}>
                                            {literalMonth[month]}
                                        </Select.Option>
                                    ))}
                            </Select>
                            {rangeActive ? (
                                <Select
                                    className={select}
                                    value={selectedYearEnd}
                                    disabled={typeof selectedMonth === 'string'}
                                    onChange={handleYearSelectEnd}
                                >
                                    {yearRange
                                        .filter(item => item.year >= selectedYear)
                                        .map(data => (
                                            <Select.Option key={data.year} value={JSON.stringify(data)}>
                                                {data.year}
                                            </Select.Option>
                                        ))}
                                </Select>
                            ) : null}
                            {rangeActive ? (
                                <Select
                                    className={select}
                                    disabled={typeof selectedYearEnd === 'string'}
                                    value={literalMonth[selectedMonthEnd] || selectedMonthEnd}
                                    onChange={e => handleMonthSelect(e, 'selectedMonthEnd')}
                                >
                                    {monthRangeEnd.length &&
                                        monthRangeEnd
                                            .filter(item =>
                                                selectedYearEnd === selectedYear ? item >= selectedMonth : item
                                            )
                                            .map(month => (
                                                <Select.Option key={month} value={month}>
                                                    {literalMonth[month]}
                                                </Select.Option>
                                            ))}
                                </Select>
                            ) : null}
                        </div>
                        <Form className={input_row} onSubmit={onSearch}>
                            <Input
                                placeholder={'מזהה לקוח'}
                                className={input_element}
                                value={client_id}
                                onInput={({ target }) => onNumberInput(target, 'client_id', this, /[^0-9]/g)}
                            />
                            <Input
                                placeholder={'מזהה סוכן'}
                                className={input_element}
                                value={agent_id}
                                onInput={({ target }) => onNumberInput(target, 'agent_id', this, /[^0-9]/g)}
                            />
                            <Button htmlType="submit">
                                <Icon type={'search'} />
                                {'חיפוש'}
                            </Button>
                            <Button onClick={resetSearchData} className={unsetMargin}>
                                {'איפוס'}
                                <Icon type={'sync'} />
                            </Button>
                        </Form>
                    </div>
                    <div className={flex}>
                        <Button onClick={onCreateRow}>
                            <Icon type={'plus-circle'} />
                            {'יצירת עמלה'}
                        </Button>
                        <Button onClick={onLoadExcel}>
                            <Icon type={downloadBtnType} />
                            {'הורדת קובץ'}
                        </Button>
                        <Button onClick={onSmsPopup}>
                            <Icon type={'mail'} />
                            {'הודעה לסוכן'}
                        </Button>
                    </div>
                </div>
                <Table
                    className={`center-table ${!loadData && list.length ? '' : none} ${tableClass}`}
                    rowKey="id"
                    columns={columns}
                    rowClassName={rClass}
                    dataSource={list}
                    scroll={{ x: 800 }}
                    bordered={true}
                    pagination={{
                        total,
                        pageSize,
                        current,
                        hideOnSinglePage: true,
                        onChange: page => getCommissionRows(page, true)
                    }}
                />
                <div className={`${loader_container} ${loadData ? '' : none}`}>
                    <Spin size={'large'} />
                </div>
                {!loadData && !list.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : null}
            </div>
        )
    }
}

export default withRouter(Reports)
